<template>
		<div class="content ac-page">
		<Header></Header>
    <div class="chances-top disflex crfff ac">
      <div @click="back">
        <img width="20" src="../../static/images/back.png"  class="nav-icon-left" />
        <div>{{$t('Back')}}</div>
      </div>
    </div>
			<div class="info crfff">
        <div class="fs50 ac">{{$t('invitation')}}</div>
        <div class="ac mt10">
          <img width="60%" src="../../static/images/int-img.png" />
        </div>
        <div class="fs33 mt20 ac">{{$t('invitationTips')}}</div>
        <div class="input-item mt50">
          <div class="input-item2">
            <input class="input" v-model="invite_url" disabled type="" placeholder="">
          </div>
        </div>
        <div class="ac mt50">
          <button class="button fw7" style="width: 100%;" id="copycode" :data-clipboard-text="invite_url" @click="copy(invite_url)">{{$t('InviteNow')}}<img style="margin-left: 10px;" width="18" src="../../static/images/copy1.png" /></button>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/Header'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
       isShow:true,
       score:'',
       invite_url:''
      }
    },
	created(){
    this.getUserInfo()
    // this.invite_url = localStorage.getItem('int_url')
	},
  methods: {
    getUserInfo(){
      let that =this;
      that.$api.get('/api/user/info',null,r =>{

        console.log(2222)
        that.$parent.returnCode(r,function(){
          console.log(333)
          that.invite_url=r.data.invite_url
          console.log(that.invite_url)
        });
      })
    },
		back(){
			this.$router.go(-1);
		},
    copy(item){
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/invitation.vue